<div class="main-container centerWithFlex">

    <div class="inner-container">

            <!-----------------------Form Header----------------------->
            <div class="formHeaderRow">
                      <div class="formRow-20">

                      </div> 
                      <div class="formRow-20">

                      </div>  
                      <div class="formRow-20 bothCenter" style="font-size: x-large;font-weight:700 ;">
                        Tech Talk
                      </div>
                      <div class="formRow-20">

                      </div>
                      <div class="formRow-20 bothCenter">
                          <button style="font-size: 14px;margin-right: 10px;" class="btn btn-outline-secondary rounded-pill button-align" (click)="cancelQuest()">Cancel</button>
                          <button style="font-size: 14px;" class="btn btn-outline-secondary rounded-pill button-align" (click)="saveQuest()">Submit</button>
                      </div>
            </div>

            <!-----------------------Form Body----------------------->
            <div class="formRow">
                    <div class="formRow-10">

                    </div>
                    <div class="formRow-17 verticalCenter">
                          Catergory
                          <span class="mandatoryAsterisk">&nbsp; *</span>
                    </div>
                    <div class="formRow-17 block-center">
                        <div class="formRow-85 verticalCenter">
                            <select [(ngModel)]="selectedCategory" [tabIndex]="1" class="form-control pointer-cursor full-height" 
                                    (ngModelChange)="selectCategory($event)">
                                <option value='' disabled selected >Select</option>
                                <option *ngFor="let cat of categoryTypes" value={{cat.name}}>
                                    {{cat.name}}</option>
                            </select>
                        </div>
                        <div class="error-field" id="cat-error-div" [ngClass]="{'hidden-field': validCategory}">
                            Category is required
                        </div>
                    </div>
                    <div class="formRow-10">

                    </div>
                    <div class="formRow-17 verticalCenter">
                         Link
                    </div>
                    <div class="formRow-17 block-center">
                        <div class="formRow-85 verticalCenter">
                            <input type="text" id="feed-lnk" name="feed-lnk" [tabIndex]="4" class="form-control full-height" [(ngModel)]="link">
                        </div>
                        <div class="error-field hidden-field" id="lnk-error-div">
                            No error
                        </div>
                    </div>
                    <div class="formRow-10">

                    </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                      Domain
                      <span class="mandatoryAsterisk">&nbsp; *</span>
                </div>
                <div class="formRow-17 block-center">
                    <div class="formRow-85 verticalCenter">
                        <select [(ngModel)]="selectedDomain" [tabIndex]="2" class="form-control pointer-cursor full-height" 
                                (ngModelChange)="selectDomain($event)">
                            <option value='' disabled selected>Select</option>
                            <option *ngFor="let dmain of domainTypes" value={{dmain.name}}>
                                {{dmain.name}}</option>
                        </select>
                    </div>
                    <div class="error-field" id="dm-error-div" [ngClass]="{'hidden-field': validDomain}">
                        Domain is required
                    </div>
                </div>
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                    Description
                    <span class="mandatoryAsterisk">&nbsp; *</span>
               </div>
               <div class="formRow-17 block-center">
                   <!-- <textarea id="te-desc" name="te-desc" [tabIndex]="3" class="form-control inp-height textAreaMinHeight" [(ngModel)]="description">
                   </textarea> -->
                   <div class="formRow-85 verticalCenter">
                       <input type="text" id="te-desc" name="te-desc" [tabIndex]="4" class="form-control full-height" (keyup)="validateDesc($event)" [(ngModel)]="description">
                   </div>
                   <div class="error-field" id="des-error-div" [ngClass]="{'hidden-field': validDesc}">
                       Description is required
                   </div>
               </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                    Puplisher wants user to contact him
                </div>
                <div class="formRow-17 verticalCenter">
                    <div class="formRow-30 verticalCenter">
                        <input type="radio" [checked]="isContact == true" (click)="setContact(true)">
                        <span>Yes</span>
                    </div>
                    <div class="formRow-30 verticalCenter">
                        <input type="radio" [checked]="isContact == false" (click)="setContact(false)">
                        <span>No</span>
                    </div>
                </div>
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                    Content details
               </div>
               <div class="formRow-17 block-center">
                   <div class="formRow-85 auto-height">
                       <textarea  id="te-det" name="te-det" [tabIndex]="4" class="form-control full-height textAreaMinHeight"
                        [(ngModel)]="contentDetails">
                       </textarea>
                   </div>
                   <div class="error-field hidden-field" id="co-error-div">
                       No error
                   </div>
               </div>
                <div class="formRow-10">

                </div>
            </div>

            <div class="formRow">
                <div class="formRow-10">

                </div>
                <div class="formRow-17 verticalCenter">
                    Tags
                </div>
                <div class="formRow-17 block-center">
                  <div class="formRow-85 auto-height">
                      <mat-form-field style="min-width: 100%;">
                          <mat-chip-list #chipList>
                              <mat-chip *ngFor="let sTag of selectedTags" [selectable]="selectable" [removable]="removable" (removed)="remove(sTag)">
                                  {{sTag.name}}
                                  <i class="fa fa-times-circle float-right" matChipRemove></i>
                              </mat-chip>
                              <input [tabIndex]="2" #searchInput (keyup)="searchTag($event, searchInput)" [matAutocomplete]="auto"
                              [matChipInputFor]="chipList" class="full-height">
                          </mat-chip-list>
                          <mat-autocomplete #auto="matAutocomplete">
                              <mat-option *ngFor="let dmain of tagList" (onSelectionChange)="tagSelected($event, dmain, searchInput)" [value]="dmain.name">
                                  {{dmain.name}}
                              </mat-option>
                          </mat-autocomplete>
                      </mat-form-field>
                  </div>
                  <div class="error-field hidden-field" id="tg-error-div">
                      No error
                  </div>
                </div>
                <div class="formRow-10">

                </div>
               
                <div class="formRow-10">

                </div>
            </div>
           
    </div>

</div>